export enum SignupRequestStatus {
  awaiting = 'AWAITING',
  approved = 'APPROVED',
  rejected = 'REJECTED',
}
